import React from 'react';

function footer() {
	return <div className="footer">Copyright 2019</div>;
}

export default footer;
